import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  category: string;
  summary: string;
  publishDate: string;
  readTime: number;
  tags: string[];
  imageUrl: string;
}

const categoryNames: Record<string, string> = {
  zonghe: '综合',
  dianying: '电影',
  dianshiju: '电视剧',
  zongyi: '综艺',
  jilupian: '纪录片',
  duanshipin: '短视频',
};

export default function ArticleCard({
  slug,
  title,
  category,
  summary,
  publishDate,
  readTime,
  tags,
  imageUrl,
}: ArticleCardProps) {
  return (
    <Link
      to={`/article/${slug}`}
      className="block bg-background-50 border border-background-200/70 rounded-lg overflow-hidden group hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div className="flex flex-col sm:flex-row">
        <div className="sm:w-56 shrink-0 h-44 sm:h-auto overflow-hidden">
          <img
            src={imageUrl}
            alt={title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex-1 p-5 flex flex-col justify-between">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <span className="text-xs px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 whitespace-nowrap font-medium">
                {categoryNames[category] || category}
              </span>
              <span className="text-xs text-foreground-500">{publishDate}</span>
              <span className="text-xs text-foreground-500">· 阅读 {readTime} 分钟</span>
            </div>
            <h3 className="font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
              {title}
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">{summary}</p>
          </div>
          <div className="flex items-center gap-1.5 mt-3 flex-wrap">
            {tags.slice(0, 3).map((tag) => (
              <span key={tag} className="text-xs px-2 py-0.5 rounded-full bg-background-100 text-foreground-500 whitespace-nowrap">
                #{tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </Link>
  );
}